// Generated by CoffeeScript 2.7.0
var DropdownSelect, capturedBackdrop;

({capturedBackdrop} = Skylark.Helpers.App);

export default DropdownSelect = (function() {
  var ACTIVE_CLASS;

  class DropdownSelect {
    constructor(element, selectCallback) {
      this.selectCallback = selectCallback;
      this.element = DomMaster.wrap(element);
      this.display_container = this.element.find('.display-container');
      this.display_value_el = this.display_container.find('.display-value');
      this.select_option_groups = this.element.find('.select-option-groups');
      this.active_option_item = this.select_option_groups.find('.select-option-item.active');
      this.__updateValue();
      this._init();
    }

    _init() {
      this.display_container.node.addEventListener('click', (event) => {
        return this._toggle();
      });
      return this.select_option_groups.node.addEventListener('click', (event) => {
        this.__activate_option_item(DomMaster.wrap(event.target).closest('.select-option-item').presence());
        return typeof this.selectCallback === "function" ? this.selectCallback(this.active_option_item, this) : void 0;
      });
    }

    _toggle() {
      this.element.toggleClass(ACTIVE_CLASS);
      if (this.element.containsClass(ACTIVE_CLASS)) {
        this.__enableBackdrop();
        if (this.active_option_item.isPresent()) {
          return this.select_option_groups.node.style.top = `-${this.active_option_item.node.offsetTop}px`;
        }
      }
    }

    __enableBackdrop() {
      return capturedBackdrop((event) => {
        return this.element.node.removeClass(ACTIVE_CLASS);
      }, void 0);
    }

    __activate_option_item(option_item) {
      var ref;
      if (option_item) {
        if ((ref = this.active_option_item.presence()) != null) {
          ref.removeClass('active');
        }
        this.active_option_item = option_item;
        this.active_option_item.addClass('active');
        this.display_value_el.node.innerHTML = this.active_option_item.node.innerHTML;
        return this.__updateValue();
      }
    }

    __updateValue() {
      return this.value = this.active_option_item.isPresent() ? this.active_option_item.data('value') : void 0;
    }

  };

  ACTIVE_CLASS = 'active';

  return DropdownSelect;

}).call(this);
